
export class Referral {
  symptoms: string;
  icd10Code: string | null;
  icdDescription: string | null;
  validICD: boolean = false;
  instructions: string | null;
  urgency: string;
  speciality: string;
  receivingPhysicianId: number[];
  appointmentFromDate: Date | null;
  appointmentToDate: Date | null;
  appointmentStatusDescription: string | null;
  appointmentStatus: string | null;
}
